const profile = {
  assets: {
    intime: {
      profile: {
        symbol: 'ITO',
        name: 'InTime',
        description:
          'In Time Foundation is committed to advancing the science of regenerative medicine and sustainable food production.',
        website: 'https://www.intimefoundation.org',
        explorer:
          'https://etherscan.io/token/0x293B0Cd0991DB07c8529fEBb01bc7D052315C5Ab',
        announcement: 'https://medium.com/@intimefoundation',
        twitter: 'intime_ito',
        facebook: 'intime.eth',
        telegram: 'InTimeFoundation',
        github: 'https://github.com/InTimeFoundation',
        image:
          'https://assets.coingecko.com/coins/images/10882/large/logo200.png',
        circulating_supply: 21044075,
        market_cap_rank: 97,
        ath: 1381.86,
        ath_change_percentage: -15.34,
        ath_date: '2022-04-11',
        atl: 9.0,
        atl_change_percentage: 12_900.62,
        atl_date: '2020-04-24',
      },
      exchanges: ['resfinex', 'ampmcx', 'worldtradeshub'],
      // tickers: [
      //   {
      //     base: 'ITO',
      //     target: 'ETH',
      //     exchange: 'Resfinex',
      //     exchange_id: 'resfinex',
      //     exchange_logo:
      //       'https://assets.coingecko.com/markets/images/497/small/Resfinex_New_Logo.png',
      //     trade_url: 'https://trade.resfinex.com/?pair=ITO_ETH',
      //   },
      // ],
    },
    ontime: {
      profile: {
        symbol: 'OTO',
        name: 'OnTime',
        description:
          'On Time Foundation is committed to sustainable urban development and energy production.',
        website: 'https://www.ontimefoundation.org',
        explorer:
          'https://etherscan.io/token/0x028CE5EA3298a50c0D8a27b937b1F48Cf0d68b56',
        announcement: 'https://medium.com/@ontimefoundation',
        twitter: 'ontime_oto',
        facebook: 'ontime.eth',
        telegram: 'OnTimeFoundation',
        github: 'https://github.com/OnTimeFoundation',
        image:
          'https://assets.coingecko.com/coins/images/10883/large/logo_(59).png',
        circulating_supply: 21042034,
        market_cap_rank: 93,
        ath: 1581.31,
        ath_change_percentage: -17.33,
        ath_date: '2022-08-14',
        atl: 9.29,
        atl_change_percentage: 13_975.78,
        atl_date: '2020-04-23',
      },
      exchanges: ['resfinex', 'ampmcx', 'worldtradeshub'],
    },
    globaledu: {
      profile: {
        symbol: 'GEFT',
        name: 'GlobalEdu',
        description: 'Education for sustainable world-class development',
        website: 'https://globaledufoundation.org',
        explorer:
          'https://etherscan.io/token/0xd0464A1985edB76Ba82602534a2d89d8cCf3B7Ec',
        announcement: 'https://medium.com/@globaledu.eth',
        twitter: 'gef_global',
        facebook: '101385331544886',
        github: 'https://github.com/GlobalEducationFoundation',
        image:
          'https://assets.coingecko.com/coins/images/11101/large/logo200_(5).png',
        circulating_supply: 1000000000,
      },
      exchanges: ['resfinex', 'ampmcx'],
    },
    envicoin: {
      profile: {
        symbol: 'ENVI',
        name: 'EnviCoin',
        description: 'The currency of smart eco-conscious engineering',
        website: 'https://www.envifoundation.org',
        explorer:
          'https://etherscan.io/token/0xc8020985a6b30773d866cbef65a7a11f96773413',
        announcement: 'https://envicoin.medium.com',
        twitter: 'envicoin_envi',
        facebook: 'EnviCoinFoundation',
        github: 'https://github.com/envicoin',
        image: '/images/ENVI.png',
        circulating_supply: 0,
      },
      exchanges: [],
    },
    roscacoin: {
      profile: {
        symbol: 'RCA',
        name: 'ROSCAcoin',
        description:
          'ROSCAcoin builds a financial solution ecosystem which leverages social capital and trusties to collaborate with better financial options by eliminating high cost of borrowing, easier financing, better investment options and diversification of risk.',
        website: 'https://rosca.vip',
        explorer:
          'https://etherscan.io/token/0xaa350dc845c91e9286c8aaaccd7602c86348a446',
        image: '/images/RCA.png',
        circulating_supply: 0,
      },
      exchanges: [],
    },
    edu3a: {
      profile: {
        symbol: 'E3A',
        name: 'Edu3A',
        description:
          'Building next-generation learning centers.',
        website: 'https://www.edu3a.org',
        explorer:
          'https://etherscan.io/token/0xBbE08fDc7EA6f1C58541DF3B40D45977954BC9d8',
        image: '/images/E3A.png',
        circulating_supply: 0,
      },
      exchanges: ['ampmcx'],
    },
  },
  exchanges: {
    worldtradeshub: {
      profile: {
        image: 'https://www.woth.io/images/logo.png',
        name: 'WorldTradesHub',
        description:
          'Launched on February 11, 2021 WorldTradesHub is a centralized exchange based in The Bahamas.',
        trust_score_rank: 82,
        centralized: true,
        website: 'https://www.woth.io',
        country: 'Bahamas',
        year: 2021,
        twitter: 'WorldTradesHub',
        other_url_1: 'https://worldtradeshub.medium.com',
        other_url_2: 'https://help.woth.io',
      },
    },
    ampmcx: {
      profile: {
        image: 'https://www.ampmcx.com/images/logo.png',
        name: 'AmPmCx',
        description:
          'Launched on February 18, 2021 AmPmCx is a centralized exchange based in The British Virgin Islands.',
        trust_score_rank: 70,
        centralized: true,
        website: 'https://www.ampmcx.com',
        country: 'British Virgin Islands',
        year: 2021,
        twitter: 'AmPmCx',
        facebook: 'https://www.facebook.com/AmPmCx',
        other_url_1: 'https://ampmcx.medium.com',
        other_url_2: 'https://help.ampmcx.com',
      },
    },
  },
};

export default profile;
